export const FETCH_DOD_REQUEST = 'FETCH_DOD_REQUEST';
export const FETCH_DOD_DATA = 'FETCH_DOD_DATA';
export const FETCH_DOD_ERROR = 'FETCH_DOD_ERROR';
export const RESET_DOD_VIEW_DATA = 'RESET_DOD_VIEW_DATA';
